let ObjectUtils = {

    has(o, key) {
        if (!(o instanceof Object)) throw new Error('Parameter is not an object');
        return !this.isNil(o) &&
            !this.isUndefined(o) &&
            Object.keys(o).indexOf(key) > -1;
    },

    isEmpty(obj) {
        return typeof obj != "number" && (
            (obj instanceof Object && Object.keys(obj).length === 0) ||
            (typeof obj === "string" && obj.length === 0)
        );
    },

    isUndefined(o) {
        return o === undefined;
    },

    isNil(o) {
        return o === null || this.isUndefined(o);
    },

    isNilOrEmpty(value) {
        return this.isNil(value) || this.isEmpty(value);
    },

    forOwn(collectionMap = {}, predicate = () => {}) {
        Object.entries(collectionMap).forEach(([key, value]) => predicate(value, key));
    },

    coalesce(value, valueIfFirstIsNullOrUndefined) {
        return this.isNil(value) ? valueIfFirstIsNullOrUndefined : value;
    },

    equals(obj1, obj2) {
        if(obj1 === obj2) {
            return true;
        } else if(obj1 && obj2 && typeof obj1 === 'object' && typeof obj2 === 'object' && Object.keys(obj1).length === Object.keys(obj2).length) {
            if(Array.isArray(obj1) === Array.isArray(obj2)){
                for (let key in obj1) {
                    if( key in obj2) {
                        if(!this.equals(obj1[key], obj2[key])) {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                }
                return true;
            }
        }
        return false;
    },

    differenceBy(array1, array2, iteratee){
        return array1.filter( array1Element =>
            array2.filter(array2Element => array2Element[iteratee] === array1Element[iteratee]).length === 0
        )
    },

    objectSize(obj) {
        return Object.keys(obj).length;
    },

    uniq(array) {
        return array.filter( (value, index, self) => self.indexOf(value) === index);
    },

    cloneObject(obj) {
        let clone = {};
        for(let i in obj) {
            if(obj[i] != null &&  typeof(obj[i])=="object")
                clone[i] = this.cloneObject(obj[i]);
            else
                clone[i] = obj[i];
        }
        return clone;
    }

};

export default ObjectUtils;